import React, {Component, Fragment, PureComponent} from "react";
import EventHelper from "../../helpers/EventHelper";
import EventHeader from "./Event/EventHeader";
import EventData from "./Event/EventData";
import lodash from "lodash";
import {connect} from "react-redux";

class EventsById extends PureComponent {
	render() {
		const {type, event_id, filter} = this.props;
		const {factors} = this.props.data;
		const data = EventHelper.parseEvents(this.props.data);

		const out = data.map((sport) => {
			return sport.leagues.map((league) => {
				const events = [];
				lodash.sortBy(league.events, e => e.time).forEach((event) => {
					events.push(
						<EventData key={`event-data-${event.id}`}
						           type={type}
						           event={event}
						           league={league}
						           factors={factors[event.id]}
						           highlight={event_id}/>
					);
				});

				return (
					<div key={`event-header-league-${league.id}`}>
						<EventHeader sport={sport} league={league}/>

						{events}
					</div>
				)
			});
		});

		return (
			<Fragment>
				{out}

				<div className="event-bookmaker-info">Букмекерская компания "Макслайн" не несёт ответственности за
					неточности в
					результатах событий, на которые принимаются live-ставки. Пользуйтесь, пожалуйста, независимыми
					источниками информации.
				</div>
			</Fragment>
		);
	}
}

export default connect(
	state => ({
		filter : state.filter
	}),
	dispatch => ({})
)(EventsById);


// WEBPACK FOOTER //
// ./src/app/components/EventById/EventsById.js